export const getRouterPath = (url: string, hasNestedRoutes = false) => {
  return `${url}${hasNestedRoutes ? '/*' : ''}`;
};
